module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-switch pt-15 pb-15 row"
  }, [_c('div', {
    staticClass: "gr-12@xs gr-8@sm gr-9@md"
  }, [_c('div', {
    staticClass: "question-switch__title"
  }, [_vm._v(_vm._s(_vm.question.category))]), _c('div', {
    staticClass: "question-switch__text"
  }, [_vm._v(_vm._s(_vm.question.measure))])]), _c('div', {
    staticClass: "gr-12@xs gr-4@sm gr-3@md txt-center@xs txt-right@md"
  }, [_c('div', {
    staticClass: "answer",
    class: _vm.answerClass
  }, [_c('span', {
    staticClass: "answer__option",
    class: {
      'answer__option--active': _vm.question.plannedToExecute === true
    },
    on: {
      "click": function($event) {
        return _vm.setAnswer('true')
      }
    }
  }, [_c('span', [_vm._v("Yes")])]), _c('span', {
    staticClass: "answer__option",
    class: {
      'answer__option--active': (typeof _vm.question.plannedToExecute === 'undefined' || _vm.question.plannedToExecute === null || _vm.question.plannedToExecute === '')
    },
    on: {
      "click": function($event) {
        return _vm.setAnswer(null)
      }
    }
  }, [_c('span', [_vm._v("•")])]), _c('span', {
    staticClass: "answer__option",
    class: {
      'answer__option--active': (_vm.question.plannedToExecute === false)
    },
    on: {
      "click": function($event) {
        return _vm.setAnswer('false')
      }
    }
  }, [_c('span', [_vm._v("No")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f117a636","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/switcher.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-f117a636","preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/switcher.vue
// module chunks = 0